<template>
  <StoryblokComponent
    v-if="story"
    :blok="story.content"
    :published-at="story.published_at"
    :parent-id="story.parent_id"
    :full-slug="story.full_slug"
  />
</template>

<script setup lang="ts">
import type { ISbStoryData } from "@storyblok/vue";

const story = ref({} as ISbStoryData);
story.value = await getStoryBlokData();

const storyblokEditor = useRoute()?.query?.["_storyblok_tk[token]"];

if (storyblokEditor) {
  onMounted(() => {
    if (story.value && story.value.id) {
      useStoryblokBridge(story.value.id, (evStory) => {
        story.value = evStory;
      });
    }
  });
}

const titleShorten = (title: string) => {
  if (title.length > 50) return `${title.slice(0, 47)}...`;
  else return title;
};

const metaStore = useMetaStore();
metaStore.pageTitle = `${titleShorten(story.value.name)} | Aussie Broadband`;
metaStore.metaTitle = story.value.content.metadata.title
  ? `${titleShorten(story.value.content.metadata.title)}`
  : `${titleShorten(story.value.name)}`;
metaStore.metaDescription = story.value.content.metadata.description
  ? story.value.content.metadata.description
  : sbDescriptionGenerator(story.value.content.articleContent);
</script>
